module.exports = __webpack_public_path__ + "static/media/hot_tlzz.b7c1187a.png";